import React from 'react';
import { CircularProgress, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { ShareRounded } from '@mui/icons-material';

import { useArchetypeShare } from '@shared/hooks/useArchetypeShare';

type Props = {
  archetype: string;
  archetypeDescription?: string | null;
  label: string;
  onAfterShare: () => void;
};

export const ShareMenuItem: React.FC<Props> = ({ archetype, archetypeDescription, label, onAfterShare }) => {
  const { share, isGenerating, hiddenCard } = useArchetypeShare({ archetype, archetypeDescription });

  const handleClick = async () => {
    await share();
    onAfterShare();
  };

  return (
    <>
      {hiddenCard}
      <MenuItem onClick={handleClick} disabled={isGenerating}>
        <ListItemIcon>
          {isGenerating ? <CircularProgress size={16} /> : <ShareRounded fontSize="small" />}
        </ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    </>
  );
};
